import { Settings } from 'features/Settings/domain/Settings.domain'
import { flatten } from 'flat'
import { restClient } from 'presentation/libs/client'

export const updateSettings = async ({ settings }: Settings.UpdateLocallyStoredSettingsPayload) =>
  await restClient.put('core/v3/users/me/settings', {
    json: flatten(settings),
  })
    .json<any>()
